import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components/macro";
import * as styles from "../../../../styles/DiaryPage";
import { resulttype } from "../../../../reducer/postpayloadtypes";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { createSearchParams, useNavigate } from "react-router-dom";
import InsectName from "../../PostDiary/component/InsectName";
import InsectImage from "../../PostDiary/component/InsectImage";
import { useSelector } from "react-redux";
import { RootState } from "../../../../reducer";

dayjs.locale("ko");

interface diaryes {
  diaries: resulttype[];
  diaryTime: {
    year: number;
    month: number;
    day: number;
	};
}

interface params {
	isArrow: string;
	id1: string;
	id2: string;
	id3: string;
	id4: string;
	id5: string;
	id6: string;
	id7: string;
}
interface Props {
	diary: diaryes;
	params: params; 
}

const SelectDiaryList = ({ diary  , params}: Props) => {
  const day = dayjs(diary.diaries[0]?.tagStdDate).format(
    "YYYY년 MM월 DD일 dddd"
  );
  const navigate = useNavigate();
	let [viewId, setViewId] = useState(0);
	let [viewBox, setViewBox] = useState<boolean>(false);

	const godetailfunc = (diary: any) => {
		navigate("/DiaryDetail?id=" + diary.diaryId.toString(), {
			state: {
				id: diary.diaryId.toString(),
				isArrow : params.isArrow,
				id1: params.id1,
				id2: params.id2,
				id3: params.id3,
				id4: params.id4,
				id5: params.id5,
				id6: params.id6,
				id7: params.id7,
				backUrl: "DiaryPage",
			}
		});
	};
	
	const viewBoxClick = (Id: number) => {
		if (viewId === Id)
		{
			setViewBox(!viewBox);			
		}
		else
		{
			setViewId(Id);
			setViewBox(true);			
		}
	};
	
  useEffect(() => {
		setViewBox(false);	
	}, [diary]);

  return (
    diary.diaries[0] && (
      <styles.Diary>
				{diary.diaries[0] && <p className="content-tit" style={{fontSize: "1.5em",fontWeight: "bold"}}>{day}</p>}

        <styles.DiaryList>
          {diary.diaries.map((diaries: resulttype, index:number) => {
            const convertinsect = () => {
              return InsectName(diaries.diaryClass?.productCode);
            };

            const boxes = diaries.places.filter((v) => v.type === "BOX");

            return (
              <styles.DiaryItem key={index}
								style={{
									/*
                  backgroundColor:
                    diaries.endFarmYn === "Y"
                      ? "rgba(195, 195, 195, 1)"
                      : "rgba(245, 245, 245, 1)",*/
									backgroundColor:"rgb(42, 58, 75)"
                }}
                onClick={() => viewBoxClick(index)}
              >
{/* 
                <styles.ItemInsectName>
                  <p className="insect-img"></p>
                  <p className="insect-name">{convertinsect()}</p>
                </styles.ItemInsectName>
								*/}
                {boxes && (
                  <styles.ItemBoxName>
                    <p className="item-box-main" style={{textAlign:"center",color: "white"}}>{boxes[0]?.name}</p>
                  </styles.ItemBoxName>
                )}
{/* 
                <styles.ItemStateName>
                  {diaries.endFarmYn === "Y" ? (
                    <p style={{ color: "white" }}>완료</p>
                  ) : (
                    <p className="cricket">{diaries.diaryClass.name}</p>
                  )}
								</styles.ItemStateName>
								*/}
              </styles.DiaryItem>
            );
          })}
				</styles.DiaryList>

				{viewBox &&(
				<styles.DiaryList>
					<div className="diary-item" style={{ width: "calc(100% - 16px)", margin: "8px 8px 0 8px" }} onClick={() => godetailfunc(diary.diaries[viewId])}>
						<div className="diary-item-status">
							<div className="diary-item-status-top">
								<styles.ItemInsectName>
                  <p className="insect-img"></p>
                  <p className="insect-name">{InsectName(diary.diaries[viewId].diaryClass?.productCode)}</p>
                </styles.ItemInsectName>
							</div>
							<div className="diary-item-status-bot" >
								<p className="diary-item-insect-name" style={{width:"calc(12% - 8px)"}}>
								{diary.diaries[viewId].places.filter((v) => v.type === "BOX")[0]?.name}
								</p>
                <styles.ItemStateName style={{margin: "unset"}}>
                  {diary.diaries[viewId].endFarmYn === "Y" ? (
                    <p style={{ color: "white" }}>완료</p>
                  ) : (
                    <p className="cricket" style={{margin: "unset"}}>{diary.diaries[viewId].diaryClass.name}</p>
                  )}
								</styles.ItemStateName>
							</div>
						</div>
					</div>
					</styles.DiaryList>
				)}
      </styles.Diary>
    )
  );
};

export default SelectDiaryList;
